document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(
    ".ambassador-recommendations[data-section-id]"
  );

  if (!sections.length || typeof Swiper === "undefined") return;

  sections.forEach((section) => {
    const swiperEl = section.querySelector(".ambassador-recommendations__swiper");
    if (!swiperEl) return;

    const transitionSpeed =
      parseInt(section.dataset.transitionSpeed, 10) || 8000;
    const spaceBetween = parseInt(section.dataset.spaceBetween, 10) || 16;
    const spaceBetweenMobile =
      parseInt(section.dataset.spaceBetweenMobile, 10) || 12;
    const grabCursor = section.dataset.grabCursor === "true";

    const swiper = new Swiper(swiperEl, {
      slidesPerView: "auto",
      spaceBetween,
      loop: true,
      speed: transitionSpeed,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      grabCursor,
      allowTouchMove: true,
      breakpoints: {
        0: {
          spaceBetween: spaceBetweenMobile,
        },
        769: {
          spaceBetween,
        },
      },
    });

    swiper.on("touchEnd", () => {
      if (swiper.autoplay) {
        swiper.autoplay.start();
      }
    });
  });
});
